import { NpiDestinationEnum, SwoopIntegrationTypeEnum } from '../../dto/recs.dto';
import { AdSet } from '../../entities/ad-set';
import { IntegrationInterface } from '../../interfaces/components/integrations/IntegrationInterface';
import { BrowserObjectModel } from '../browser-object-model';
import { UserContext } from '../context/user.context';
import { Injectable } from '../dependency-injection/decorators';
import { IntegrationStoppedExecutionException } from '../exception/integration-stopped-execution.exception';

@Injectable()
export class SwoopCallbackOnlyIntegration implements IntegrationInterface {
  public constructor (
    protected readonly browserObjectModel: BrowserObjectModel,
    protected readonly userContext: UserContext,
  ) {
  }

  public async run (adSet: AdSet): Promise<void> {
    const callback = this.browserObjectModel.getWindow()[ '_npi_cb' ];

    if (!this.supports(adSet) || typeof callback === 'undefined') {
      return;
    }

    const encryptedNpiNumber = this.userContext
      .getNpis()
      .find((innerNpi) => innerNpi.getDestination() === NpiDestinationEnum.SWOOP)
      ?.getEncryptedNumber()
    ;

    if (encryptedNpiNumber) {
      callback(encryptedNpiNumber);

      throw new IntegrationStoppedExecutionException(this);
    }
  }

  public supports (adSet: AdSet): boolean {
    return adSet.getSettings().getSwoopIntegrationType() === SwoopIntegrationTypeEnum.CALLBACK_ONLY;
  }
}
